/* eslint-disable guard-for-in */
import React, { Component } from "react";
import PropTypes from "prop-types";
import axios from "axios";
import { connect } from "react-redux";
import styled from "styled-components";

import { setCookie } from "../utils";
import { submitForm } from "../redux/actions/main";
import { setData } from "../redux/actions/questions";

const Button = styled.button`
  cursor: pointer;
  width: 300px;
  height: 45px;
  color: #000;
  background-color: #facd22;
  margin: 0 auto;
  text-align: center;
  display: block;
  position: relative;
  border: none;
  box-shadow: none;
  border-radius: 2px;
  font-size: 16px;
  font-weight: bold;
  text-transform: uppercase;
  opacity: 1;
  transition: ease 0.2s opacity;
  &:disabled {
    opacity: 0.5;
  }
`;

class Submit extends Component {
  constructor(props) {
    super(props);
    this.state = { loading: false };
  }

  submit = () => {
    const { submitform, setdata, questions, regions, main } = this.props;
    window.dataLayer.push({
      category: "Email_Submit",
      event: "Click_Submit",
      label: "Click_Submit"
    });
    let errors = false;
    if (!regions.activeRegion) {
      setdata("regionError", true);
      errors = true;
    } else {
      setdata("regionError", false);
    }
    // eslint-disable-next-line no-restricted-syntax
    for (const item in questions) {
      if (item.indexOf("dropdown") === -1 && item.indexOf("error") === -1) {
        if (!questions[item]) {
          setdata(`${item}error`, true);
          errors = true;
        } else {
          setdata(`${item}error`, false);
        }
      }
    }

    if (errors) return;
    this.setState({ loading: true });
    const country = regions.activeRegion;
    const urlParams = new URLSearchParams(window.location.search);

    let apiURL = `https://htz2166-back.herokuapp.com`;
    if (
      window.location.hostname === "localhost" ||
      window.location.hostname === "127.0.0.1"
    ) {
      apiURL = `http://localhost:3666`;

      console.log(`Sending an API request to ${apiURL}`);
      console.log(`With the following props/data`);
      console.log(this.props);
    }
    window.gtag('event', 'conversion', {
      'allow_custom_scripts': true,
      'send_to': 'DC-11393422/crmla0/hertz0+standard'
    });
    axios({
      method: "post",
      url: apiURL + "/",
      data: {
        email: main.subscriberkey,
        country,
        destinations: questions.country,
        car: questions.preference,
        travels: questions.often,
        purpose: questions.purpose,
        collection: urlParams.get("dcid") || "",
        SourceProject: urlParams.get("sp") || ""
      }
    })
      .then(() => {
        setCookie("formsubmitted", 1);
        submitform(true);
        window.location.reload();
      })
      .catch(error => {
        this.setState({ loading: false });
        if (!error.status) {
          console.error(error);
        }
      });
  };

  render() {
    const { copy } = this.props;
    const { loading } = this.state;
    return (
      <div>
        <Button type="submit" disabled={loading} onClick={this.submit}>
          {copy.options.action}
        </Button>
        <p
          className="legal"
          style={{
            textAlign: `center`,
            fontSize: `11px`,
            color: `#9b9b9b`,
            marginTop: `120px`,
            width: `75%`,
            marginLeft: `auto`,
            marginRight: `auto`
          }}
        >
          {copy.thanks.subtitle}
        </p>
      </div>
    );
  }
}

Submit.defaultProps = {};

Submit.propTypes = {
  submitform: PropTypes.func.isRequired,
  copy: PropTypes.objectOf(PropTypes.object).isRequired
};

const mapDispatchToProps = dispatch => ({
  submitform: bool => dispatch(submitForm(bool)),
  setdata: (key, val) => dispatch(setData(key, val))
});

const mapStateToProps = state => ({ ...state });

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Submit);
